export default __webpack_public_path__ + "static/media/textBinIconLight.1c3c90fe.svg";